import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { BtnTheme } from '../../type/btnTheme.type';
import { FontWeight } from '../../type/fontWeight.type';
import { BtnType } from '../../type/btnType.type';
import { ThemePalette } from '@angular/material/core';
import { BtnIconPosition } from '../../type/btnIconPosition.type';

@Component({
  selector: 'app-btn-icon-right',
  templateUrl: './btn-icon-right.component.html',
  styleUrls: ['./btn-icon-right.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BtnIconRightComponent {
  @Input('theme') theme: BtnTheme;
  @Input('text') text: string = 'Placeholder';
  @Input('icon') icon: string = 'favorite';
  @Input('color') color: ThemePalette;
  @Input('uppercase') uppercase: boolean = true;
  @Input('iconColor') iconColor: ThemePalette;
  @Input('iconPosition') iconPosition: BtnIconPosition = 'right';
  @Input('fontWeight') fontWeight: FontWeight = 400;
  @Input('type') type: BtnType = 'button';
}
